<template>
  <div
    class="nameplate-form"
    :class="{'is-success': state.form}">
    <div class="nameplate-form__item">
      <label class="nameplate-form__label" for="name">お子様のお名前</label>
      <input
        id="name"
        class="nameplate-form__input"
        type="text"
        v-model="value.name"
        :placeholder="[state.name === 'focus' ? '' : ($route.path.match(/gogatsu/) ? '陽一（よういち）'  : '雛子')]"
        @focus="onFocus('name')"
        @blur="onBlur('name')"
        @keyup="onKeyup('name')">
        <div
          class="nameplate-form__input-border"
          :class="[state.name === 'focus' ? 'is-show' : '']">
        </div>
    </div>
    <div class="nameplate-form__item">
      <label class="nameplate-form__label" for="birthday">生年月日</label>
      <input
        id="birthday"
        class="nameplate-form__input"
        type="text"
        v-model="value.birthday"
        :placeholder="[state.birthday === 'focus' ? '' : ($route.path.match(/gogatsu/) ? '令和元年5月5日 / 2019年5月5日'  : '平成31年3月3日 / 2019年3月3日')]"
        @focus="onFocus('birthday')"
        @blur="onBlur('birthday')"
        @keyup="onKeyup('birthday')">
      <div
        class="nameplate-form__input-border"
        :class="[state.birthday === 'focus' ? 'is-show' : '']">
      </div>
    </div>
  </div>
</template>



<script>
export default {
  props: [
    'value',
  ],
  data() {
    return {
      state: {
        form: false,
        name: false,
        birthday: null,
      }
    }
  },
  methods: {
    onFocus(value) {
      this.$set(this.state, value, 'focus')
      this.$set(this.state, 'form', false)
    },
    onBlur(value) {
      this.$set(this.state, value, false)
      if (this.value.name && this.value.birthday) {
        this.$set(this.state, 'form', true)
      }
    },
    onKeyup(value) {
    },
  }
}
</script>



<style lang="scss">
.nameplate-form {
  $e: &;
  transition: $transition;
  box-shadow: 0 8px 17px 2px rgba(#000, 0.07), 0 3px 14px 2px rgba(#000, 0.06), 0 0 5px -3px rgba(#000, 0.1);
  &.is-success {
    box-shadow: none;
  }

  &__item {
    position: relative;
    & + #{$e}__item {
      border-top: 1px solid $oc-gray-1;
    }
  }

  &__label {
    position: absolute;
    top: 15px;
    left: 18px;
    z-index: 2;
    font-size: 10px;
    color: $oc-gray-8;
    @include breakpoints-min(lg) {
      top: 13px;
    }
  }

  &__input {
    -webkit-appearance: none;
    outline: none;
    position: relative;
    z-index: 1;
    border-radius: 0;
    border: none;
    font-family: inherit;
    font-size: 16px;
    line-height: 22px;
    color: $color;
    width: 100%;
    height: 61px;
    padding: 28px 16px 10px;
    &::placeholder {
      color: $oc-gray-6;
    }
    &:-ms-input-placeholder {
      color: $oc-gray-6;
    }
    &::-ms-input-placeholder {
      color: $oc-gray-6;
    }
    @include breakpoints-min(lg) {
      font-size: 13px;
      height: 57px;
      padding: 22px 16px 4px;
    }
  }

  &__input-border {
    transition: $transition;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    background-color: $accent-color;
    width: 4px;
    height: 100%;
    &.is-show {
      opacity: 1;
    }
  }
}

.app-gogatsu {
    .nameplate-form {
        $e: &;
        
        &__input-border {
            background-color: $gogatsu-accent-color;
        }
    }
}
</style>
